import styled, { css } from 'styled-components';
import { media } from 'core/layout';

const buttonOffset = ({compact, hasLabel}) => {
  let offset = 8;
  if (!compact) {
    offset *= 1.5;
  }
  if (hasLabel) {
    offset *= -1;
  }
  return offset;
};

const ActionAlignment = styled.section`
  transform: translate(${buttonOffset}px, ${({compact}) => compact ? 8 : 24}px);

  ${({hasLabel}) => !hasLabel && css`
    display: flex;
    justify-content: flex-end;
  `};

  & > button {
    min-width: 0;
  }
`;

export default ActionAlignment;



// WEBPACK FOOTER //
// ./src/elements/Card/components/Content/styled/ActionAlignment.js